import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "custom-padding-30" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-lg-6 order-lg-1 order-2" }
const _hoisted_8 = { class: "tax-summary-info d-none d-lg-block" }
const _hoisted_9 = { class: "summary-item mb-2" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "summary-value fw-bold" }
const _hoisted_12 = { class: "summary-item mb-2" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "summary-value fw-bold" }
const _hoisted_15 = { class: "summary-item mb-2" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "summary-value fw-bold" }
const _hoisted_18 = { class: "summary-item mb-2" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "summary-value fw-bold" }
const _hoisted_21 = { class: "summary-item mb-2" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "summary-value fw-bold" }
const _hoisted_24 = { class: "summary-item mb-2" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "summary-value fw-bold" }
const _hoisted_27 = {
  key: 1,
  class: "summary-item mb-2"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "summary-value fw-bold" }
const _hoisted_30 = { class: "summary-item mb-2" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "summary-value fw-bold text-danger" }
const _hoisted_33 = { class: "mt-3 pt-3 border-top" }
const _hoisted_34 = { class: "summary-item mb-2" }
const _hoisted_35 = { class: "summary-label d-flex align-items-center" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "summary-value fw-bold" }
const _hoisted_38 = { class: "summary-item mb-2" }
const _hoisted_39 = { class: "summary-label d-flex align-items-center" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "summary-value fw-bold" }
const _hoisted_42 = { class: "summary-item mb-2" }
const _hoisted_43 = { class: "summary-label d-flex align-items-center" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "summary-value fw-bold" }
const _hoisted_46 = { class: "summary-item mb-2" }
const _hoisted_47 = { class: "summary-label d-flex align-items-center" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { class: "summary-value fw-bold" }
const _hoisted_50 = { class: "summary-item mb-2" }
const _hoisted_51 = { class: "summary-label d-flex align-items-center" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { class: "summary-value fw-bold" }
const _hoisted_54 = { class: "summary-item mb-2" }
const _hoisted_55 = { class: "summary-label d-flex align-items-center" }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = { class: "summary-value fw-bold" }
const _hoisted_58 = { class: "summary-item mb-0" }
const _hoisted_59 = { class: "summary-label d-flex align-items-center" }
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = { class: "summary-value fw-bold text-success" }
const _hoisted_62 = { class: "col-lg-6 order-lg-2 order-1" }
const _hoisted_63 = { style: {"margin":"-8px 0 -13px 0"} }
const _hoisted_64 = { class: "d-flex gap-2 justify-content-center mt-3 flex-wrap" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = { class: "d-flex align-items-center" }
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = { class: "d-flex align-items-center" }
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = { class: "d-flex align-items-center" }
const _hoisted_72 = ["innerHTML"]
const _hoisted_73 = { class: "d-flex align-items-center" }
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = { class: "d-flex align-items-center" }
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = { class: "col-12 d-lg-none order-3" }
const _hoisted_80 = { class: "mb-2 mt-3" }
const _hoisted_81 = { class: "tax-summary-info" }
const _hoisted_82 = { class: "summary-item mb-2" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = { class: "summary-value fw-bold" }
const _hoisted_85 = { class: "summary-item mb-2" }
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = { class: "summary-value fw-bold" }
const _hoisted_88 = { class: "summary-item mb-2" }
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = { class: "summary-value fw-bold" }
const _hoisted_91 = { class: "summary-item mb-2" }
const _hoisted_92 = ["innerHTML"]
const _hoisted_93 = { class: "summary-value fw-bold" }
const _hoisted_94 = { class: "summary-item mb-2" }
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = { class: "summary-value fw-bold" }
const _hoisted_97 = { class: "summary-item mb-2" }
const _hoisted_98 = ["innerHTML"]
const _hoisted_99 = { class: "summary-value fw-bold" }
const _hoisted_100 = {
  key: 1,
  class: "summary-item mb-2"
}
const _hoisted_101 = ["innerHTML"]
const _hoisted_102 = { class: "summary-value fw-bold" }
const _hoisted_103 = { class: "summary-item mb-2" }
const _hoisted_104 = ["innerHTML"]
const _hoisted_105 = { class: "summary-value fw-bold text-danger" }
const _hoisted_106 = { class: "mt-3 pt-3 border-top" }
const _hoisted_107 = { class: "summary-item mb-2" }
const _hoisted_108 = { class: "summary-label d-flex align-items-center" }
const _hoisted_109 = ["innerHTML"]
const _hoisted_110 = { class: "summary-value fw-bold" }
const _hoisted_111 = { class: "summary-item mb-2" }
const _hoisted_112 = { class: "summary-label d-flex align-items-center" }
const _hoisted_113 = ["innerHTML"]
const _hoisted_114 = { class: "summary-value fw-bold" }
const _hoisted_115 = { class: "summary-item mb-2" }
const _hoisted_116 = { class: "summary-label d-flex align-items-center" }
const _hoisted_117 = ["innerHTML"]
const _hoisted_118 = { class: "summary-value fw-bold" }
const _hoisted_119 = { class: "summary-item mb-2" }
const _hoisted_120 = { class: "summary-label d-flex align-items-center" }
const _hoisted_121 = ["innerHTML"]
const _hoisted_122 = { class: "summary-value fw-bold" }
const _hoisted_123 = { class: "summary-item mb-2" }
const _hoisted_124 = { class: "summary-label d-flex align-items-center" }
const _hoisted_125 = ["innerHTML"]
const _hoisted_126 = { class: "summary-value fw-bold" }
const _hoisted_127 = { class: "summary-item mb-2" }
const _hoisted_128 = { class: "summary-label d-flex align-items-center" }
const _hoisted_129 = ["innerHTML"]
const _hoisted_130 = { class: "summary-value fw-bold" }
const _hoisted_131 = { class: "summary-item mb-0" }
const _hoisted_132 = { class: "summary-label d-flex align-items-center" }
const _hoisted_133 = ["innerHTML"]
const _hoisted_134 = { class: "summary-value fw-bold text-success" }
const _hoisted_135 = {
  key: 1,
  style: {"margin":"-8px 0 -13px 0"}
}
const _hoisted_136 = {
  key: 2,
  class: "mt-0"
}
const _hoisted_137 = ["data-bs-target"]
const _hoisted_138 = ["id", "aria-labelledby"]
const _hoisted_139 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" }
const _hoisted_140 = { class: "modal-content" }
const _hoisted_141 = { class: "modal-header" }
const _hoisted_142 = ["id"]
const _hoisted_143 = { class: "modal-body p-4" }
const _hoisted_144 = { class: "mb-4" }
const _hoisted_145 = { class: "d-flex align-items-start" }
const _hoisted_146 = {
  class: "mb-0",
  style: {"line-height":"1.6"}
}
const _hoisted_147 = { class: "calculation-steps-list" }
const _hoisted_148 = { class: "step-header d-flex justify-content-between align-items-start mb-2" }
const _hoisted_149 = { class: "step-title" }
const _hoisted_150 = { class: "fw-semibold" }
const _hoisted_151 = { class: "step-result text-dark fw-bold" }
const _hoisted_152 = {
  key: 0,
  class: "step-formula-box mb-2"
}
const _hoisted_153 = { class: "formula-content" }
const _hoisted_154 = { class: "formula-code" }
const _hoisted_155 = { class: "step-body" }
const _hoisted_156 = { class: "step-description text-muted mb-0" }
const _hoisted_157 = { class: "modal-footer border-0 p-4 pt-0" }
const _hoisted_158 = {
  type: "button",
  class: "btn btn-primary text-white",
  "data-bs-dismiss": "modal"
}

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { t } from '@/utils/i18nHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'TaxBreakdownChart',
  props: {
  title: {
    type: String,
    required: true,
  },
  chartTaxTotal: {
    type: Number,
    required: true,
  },
  chartInpsVariableTotal: {
    type: Number,
    required: true,
  },
  chartInpsFixedTotal: {
    type: Number,
    required: true,
  },
  // Nuovi props per casse professionali
  chartContribSoggettivo: {
    type: Number,
    default: 0,
  },
  chartContribIntegrativo: {
    type: Number,
    default: 0,
  },
  chartContribMaternita: {
    type: Number,
    default: 0,
  },
  fatturato: {
    type: Number,
    required: true,
  },
  showSummary: {
    type: Boolean,
    default: false,
  },
  summaryData: {
    type: Object,
    default: () => ({}),
  },
  // Tipo di regime per determinare quali contributi mostrare
  contributionType: {
    type: String,
    default: 'INPS', // 'INPS' o 'PROFESSIONAL'
  },
  // Dettagli del calcolo dal backend
  calculationDetails: {
    type: Object as () => { summary: string; steps: Array<{ title: string; description: string; formula?: string; result: string }> } | null,
    default: null,
  },
  // Anno di riferimento del fatturato
  year: {
    type: Number,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const isClient = ref(false);
const showDetails = ref(false);
const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1200);

// Genera un ID univoco per il modal
const modalId = ref(`calc-${Math.random().toString(36).substring(2, 11)}`);

// Calcoliamo l'utile come differenza tra fatturato e totale tasse
const totalTaxes = computed(() => {
  if (props.contributionType === 'PROFESSIONAL') {
    return props.chartTaxTotal + props.chartContribSoggettivo + props.chartContribIntegrativo + props.chartContribMaternita;
  }
  return props.chartTaxTotal + props.chartInpsVariableTotal + props.chartInpsFixedTotal;
});

const utile = computed(() =>
  Math.max(0, props.fatturato - totalTaxes.value)
);

const chartSeries = computed(() => {
  if (props.contributionType === 'PROFESSIONAL') {
    return [
      props.chartTaxTotal,
      props.chartContribSoggettivo,
      props.chartContribIntegrativo,
      props.chartContribMaternita,
      utile.value,
    ];
  }
  return [
    props.chartTaxTotal,
    props.chartInpsVariableTotal,
    props.chartInpsFixedTotal,
    utile.value,
  ];
});

// Uso diretto della funzione t() nelle computed

const chartOptions = computed(() => {
  let labels, colors;

  if (props.contributionType === 'PROFESSIONAL') {
    labels = [
      t('fr.tax_breakdown.chart_label_substitute_tax', 'Imposta Sostitutiva'),
      t('fr.tax_breakdown.chart_label_contrib_soggettivo', 'Contrib. Soggettivo'),
      t('fr.tax_breakdown.chart_label_contrib_integrativo', 'Contrib. Integrativo'),
      t('fr.tax_breakdown.chart_label_contrib_maternita', 'Contrib. Maternità'),
      t('fr.tax_breakdown.chart_label_profit', 'Utile')
    ];
    colors = ["#dc3545", "#fd7e14", "#ffc107", "#9c27b0", "#28a745"]; // Rosso, Arancione, Giallo, Viola per maternità, Verde
  } else {
    labels = [
      t('fr.tax_breakdown.chart_label_substitute_tax', 'Imposta Sostitutiva'),
      t('fr.tax_breakdown.chart_label_inps_variable', 'Contributi INPS Variabili'),
      t('fr.tax_breakdown.chart_label_inps_fixed', 'Contributi INPS Fissi'),
      t('fr.tax_breakdown.chart_label_profit', 'Utile')
    ];
    colors = ["#dc3545", "#fd7e14", "#ffc107", "#28a745"]; // Rosso per tasse, Arancione per INPS Var, Giallo per INPS Fissi, Verde per utile
  }

  // Cattura il valore del fatturato per usarlo nel formatter
  const fatturatoValue = props.fatturato;

  return {
  chart: {
    height: 200,
    type: "donut",
  },
  labels,
  colors,
  stroke: {
    width: 1,
    show: true,
    colors: ["#ffffff"],
    lineCap: "round",
  },
  legend: {
    show: false,
  },
  plotOptions: {
    pie: {
      expandOnClick: false,
      donut: {
        size: "70%",
        labels: {
          show: true,
          name: {
            color: "#64748B",
          },
          value: {
            show: true,
            color: "#64748B",
            fontSize: "18px",
            fontWeight: "600",
            offsetY: 1,
            formatter: function(val: any) {
              const numVal = parseFloat(val);
              if (!isFinite(numVal)) return '€ 0,00'; // Use isFinite for a more robust check
              const formatted = numVal.toFixed(2);
              const parts = formatted.split('.');
              const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
              const decimalPart = parts[1];
              return '€ ' + integerPart + ',' + decimalPart;
            }
          },
          total: {
            show: true,
            label: props.year ? t('fr.tax_breakdown.chart_total_label_with_year', `Fatturato ${props.year}`, { year: props.year }) : t('fr.tax_breakdown.chart_total_label', 'Totale'),
            color: "#64748B",
            fontSize: "12px",
            fontWeight: "400",
            formatter: function(w: any) {
              // Mostra sempre il fatturato originale, non la somma delle serie
              const total = fatturatoValue;
              const formatted = total.toFixed(2);
              const parts = formatted.split('.');
              const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
              const decimalPart = parts[1];
              return '€ ' + integerPart + ',' + decimalPart;
            }
          },
        },
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    enabled: true,
    custom: function({ series, seriesIndex, w }: any) {
      const value = series[seriesIndex];
      const label = w.globals.labels[seriesIndex];
      const numVal = parseFloat(value);
      let formattedValue;
      if (isNaN(numVal)) {
        formattedValue = '€ 0,00';
      } else {
        const formatted = numVal.toFixed(2);
        const parts = formatted.split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const decimalPart = parts[1];
        formattedValue = '€ ' + integerPart + ',' + decimalPart;
      }
      return '<div class="custom-tooltip" style="padding: 8px 12px; background: #000; color: #fff; border-radius: 4px; font-size: 12px;">' +
             '<strong>' + label + '</strong><br/>' +
             formattedValue +
             '</div>';
    }
  },
  };
});

// Funzione per formattare la valuta
const formatCurrency = (value: number) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '€ 0,00';
  }

  const formatted = Math.abs(value).toFixed(2);
  const parts = formatted.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];

  const sign = value < 0 ? '-' : '';
  return sign + '€ ' + integerPart + ',' + decimalPart;
};

// Funzione per toggle dei dettagli
const toggleDetails = () => {
  showDetails.value = !showDetails.value;
};

// Funzione per gestire il resize della finestra
const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  isClient.value = true;

  if (typeof window !== 'undefined') {
    window.addEventListener('resize', handleResize);
    windowWidth.value = window.innerWidth;
  }
});

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', handleResize);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", {
          class: "fw-semibold",
          innerHTML: __props.title
        }, null, 8, _hoisted_3),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("small", {
            innerHTML: _unref(t)('fr.tax_breakdown.chart_description', 'Suddivisione del fatturato tra tasse e utile')
          }, null, 8, _hoisted_5)
        ]),
        (__props.showSummary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "summary-label",
                      innerHTML: __props.year ? _unref(t)('fr.tax_summary.annual_revenue_with_year', `Fatturato Annuo ${__props.year}`, { year: __props.year }) : _unref(t)('fr.tax_summary.annual_revenue', 'Fatturato Annuo')
                    }, null, 8, _hoisted_10),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(formatCurrency(__props.summaryData.fatturato)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "summary-label",
                      innerHTML: _unref(t)('fr.tax_summary.flat_rate', 'Aliquota Forfettaria')
                    }, null, 8, _hoisted_13),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(__props.summaryData.aliquota) + "%", 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: "summary-label",
                      innerHTML: _unref(t)('fr.tax_summary.taxable_income', 'Reddito Imponibile')
                    }, null, 8, _hoisted_16),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(formatCurrency(__props.summaryData.redditoImponibile)), 1)
                  ]),
                  (__props.contributionType === 'INPS')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", {
                            class: "summary-label",
                            innerHTML: _unref(t)('fr.tax_summary.inps_balance', 'Saldo Contributi INPS')
                          }, null, 8, _hoisted_19),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(formatCurrency(__props.summaryData.inpsSaldo)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", {
                            class: "summary-label",
                            innerHTML: _unref(t)('fr.tax_summary.inps_advances', 'Acconti Contributi INPS')
                          }, null, 8, _hoisted_22),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(formatCurrency(__props.summaryData.inpsAcconti)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", {
                            class: "summary-label",
                            innerHTML: _unref(t)('fr.tax_summary.irpef_advances', 'Acconti IRPEF')
                          }, null, 8, _hoisted_25),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(formatCurrency(__props.summaryData.irpefAcconti)), 1)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", {
                          class: "summary-label",
                          innerHTML: _unref(t)('fr.tax_summary.contrib_total', 'Totale Contributi')
                        }, null, 8, _hoisted_28),
                        _createElementVNode("div", _hoisted_29, _toDisplayString(formatCurrency(__props.chartContribSoggettivo + __props.chartContribIntegrativo + __props.chartContribMaternita)), 1)
                      ])),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", {
                      class: "summary-label fw-semibold",
                      innerHTML: _unref(t)('fr.tax_summary.total_taxes', 'Totale da versare')
                    }, null, 8, _hoisted_31),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(formatCurrency(__props.summaryData.totaleImposte)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", {
                          class: "d-inline-block rounded-circle me-2",
                          style: {"width":"8px","height":"8px","background-color":"#dc3545"}
                        }, null, -1)),
                        _createElementVNode("span", {
                          innerHTML: _unref(t)('fr.tax_breakdown.legend_substitute_tax', 'Imp. Sost.')
                        }, null, 8, _hoisted_36)
                      ]),
                      _createElementVNode("div", _hoisted_37, _toDisplayString(formatCurrency(__props.chartTaxTotal)), 1)
                    ]),
                    (__props.contributionType === 'PROFESSIONAL')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _cache[1] || (_cache[1] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#fd7e14"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_soggettivo', 'Contrib. Sogg.')
                              }, null, 8, _hoisted_40)
                            ]),
                            _createElementVNode("div", _hoisted_41, _toDisplayString(formatCurrency(__props.chartContribSoggettivo)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _cache[2] || (_cache[2] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#ffc107"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_integrativo', 'Contrib. Integr.')
                              }, null, 8, _hoisted_44)
                            ]),
                            _createElementVNode("div", _hoisted_45, _toDisplayString(formatCurrency(__props.chartContribIntegrativo)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _cache[3] || (_cache[3] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#9c27b0"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_maternita', 'Contrib. Matern.')
                              }, null, 8, _hoisted_48)
                            ]),
                            _createElementVNode("div", _hoisted_49, _toDisplayString(formatCurrency(__props.chartContribMaternita)), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _cache[4] || (_cache[4] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#fd7e14"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_inps_variable', 'INPS Var.')
                              }, null, 8, _hoisted_52)
                            ]),
                            _createElementVNode("div", _hoisted_53, _toDisplayString(formatCurrency(__props.chartInpsVariableTotal)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _cache[5] || (_cache[5] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#ffc107"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_inps_fixed', 'INPS Fis.')
                              }, null, 8, _hoisted_56)
                            ]),
                            _createElementVNode("div", _hoisted_57, _toDisplayString(formatCurrency(__props.chartInpsFixedTotal)), 1)
                          ])
                        ], 64)),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", {
                          class: "d-inline-block rounded-circle me-2",
                          style: {"width":"8px","height":"8px","background-color":"#28a745"}
                        }, null, -1)),
                        _createElementVNode("span", {
                          innerHTML: _unref(t)('fr.tax_breakdown.legend_profit', 'Utile')
                        }, null, 8, _hoisted_60)
                      ]),
                      _createElementVNode("div", _hoisted_61, _toDisplayString(formatCurrency(utile.value)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  (isClient.value)
                    ? (_openBlock(), _createBlock(_component_apexchart, {
                        key: 0,
                        type: "donut",
                        height: "200",
                        options: chartOptions.value,
                        series: chartSeries.value
                      }, null, 8, ["options", "series"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", {
                      class: "d-inline-block rounded-circle",
                      style: {"width":"8px","height":"8px","background-color":"#dc3545"}
                    }, null, -1)),
                    _createElementVNode("span", {
                      class: "ms-1 small",
                      innerHTML: _unref(t)('fr.tax_breakdown.legend_substitute_tax', 'Imp. Sost.')
                    }, null, 8, _hoisted_66)
                  ]),
                  (__props.contributionType === 'PROFESSIONAL')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_67, [
                          _cache[8] || (_cache[8] = _createElementVNode("span", {
                            class: "d-inline-block rounded-circle",
                            style: {"width":"8px","height":"8px","background-color":"#fd7e14"}
                          }, null, -1)),
                          _createElementVNode("span", {
                            class: "ms-1 small",
                            innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_soggettivo', 'Sogg.')
                          }, null, 8, _hoisted_68)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _cache[9] || (_cache[9] = _createElementVNode("span", {
                            class: "d-inline-block rounded-circle",
                            style: {"width":"8px","height":"8px","background-color":"#ffc107"}
                          }, null, -1)),
                          _createElementVNode("span", {
                            class: "ms-1 small",
                            innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_integrativo', 'Integr.')
                          }, null, 8, _hoisted_70)
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", {
                            class: "d-inline-block rounded-circle",
                            style: {"width":"8px","height":"8px","background-color":"#9c27b0"}
                          }, null, -1)),
                          _createElementVNode("span", {
                            class: "ms-1 small",
                            innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_maternita', 'Matern.')
                          }, null, 8, _hoisted_72)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_73, [
                          _cache[11] || (_cache[11] = _createElementVNode("span", {
                            class: "d-inline-block rounded-circle",
                            style: {"width":"8px","height":"8px","background-color":"#fd7e14"}
                          }, null, -1)),
                          _createElementVNode("span", {
                            class: "ms-1 small",
                            innerHTML: _unref(t)('fr.tax_breakdown.legend_inps_variable', 'INPS Var.')
                          }, null, 8, _hoisted_74)
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _cache[12] || (_cache[12] = _createElementVNode("span", {
                            class: "d-inline-block rounded-circle",
                            style: {"width":"8px","height":"8px","background-color":"#ffc107"}
                          }, null, -1)),
                          _createElementVNode("span", {
                            class: "ms-1 small",
                            innerHTML: _unref(t)('fr.tax_breakdown.legend_inps_fixed', 'INPS Fis.')
                          }, null, 8, _hoisted_76)
                        ])
                      ], 64)),
                  _createElementVNode("div", _hoisted_77, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                      class: "d-inline-block rounded-circle",
                      style: {"width":"8px","height":"8px","background-color":"#28a745"}
                    }, null, -1)),
                    _createElementVNode("span", {
                      class: "ms-1 small",
                      innerHTML: _unref(t)('fr.tax_breakdown.legend_profit', 'Utile')
                    }, null, 8, _hoisted_78)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary btn-sm w-100",
                    type: "button",
                    onClick: toggleDetails
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas", showDetails.value ? 'fa-chevron-up' : 'fa-chevron-down'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(showDetails.value ? _unref(t)('fr.tax_summary.hide_details', 'Nascondi dettagli') : _unref(t)('fr.tax_summary.show_details', 'Mostra dettagli')), 1)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", {
                      class: "summary-label",
                      innerHTML: __props.year ? _unref(t)('fr.tax_summary.annual_revenue_with_year', `Fatturato Annuo ${__props.year}`, { year: __props.year }) : _unref(t)('fr.tax_summary.annual_revenue', 'Fatturato Annuo')
                    }, null, 8, _hoisted_83),
                    _createElementVNode("div", _hoisted_84, _toDisplayString(formatCurrency(__props.summaryData.fatturato)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", {
                      class: "summary-label",
                      innerHTML: _unref(t)('fr.tax_summary.flat_rate', 'Aliquota Forfettaria')
                    }, null, 8, _hoisted_86),
                    _createElementVNode("div", _hoisted_87, _toDisplayString(__props.summaryData.aliquota) + "%", 1)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", {
                      class: "summary-label",
                      innerHTML: _unref(t)('fr.tax_summary.taxable_income', 'Reddito Imponibile')
                    }, null, 8, _hoisted_89),
                    _createElementVNode("div", _hoisted_90, _toDisplayString(formatCurrency(__props.summaryData.redditoImponibile)), 1)
                  ]),
                  (__props.contributionType === 'INPS')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", {
                            class: "summary-label",
                            innerHTML: _unref(t)('fr.tax_summary.inps_balance', 'Saldo Contributi INPS')
                          }, null, 8, _hoisted_92),
                          _createElementVNode("div", _hoisted_93, _toDisplayString(formatCurrency(__props.summaryData.inpsSaldo)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", {
                            class: "summary-label",
                            innerHTML: _unref(t)('fr.tax_summary.inps_advances', 'Acconti Contributi INPS')
                          }, null, 8, _hoisted_95),
                          _createElementVNode("div", _hoisted_96, _toDisplayString(formatCurrency(__props.summaryData.inpsAcconti)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", {
                            class: "summary-label",
                            innerHTML: _unref(t)('fr.tax_summary.irpef_advances', 'Acconti IRPEF')
                          }, null, 8, _hoisted_98),
                          _createElementVNode("div", _hoisted_99, _toDisplayString(formatCurrency(__props.summaryData.irpefAcconti)), 1)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_100, [
                        _createElementVNode("div", {
                          class: "summary-label",
                          innerHTML: _unref(t)('fr.tax_summary.contrib_total', 'Totale Contributi')
                        }, null, 8, _hoisted_101),
                        _createElementVNode("div", _hoisted_102, _toDisplayString(formatCurrency(__props.chartContribSoggettivo + __props.chartContribIntegrativo + __props.chartContribMaternita)), 1)
                      ])),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", {
                      class: "summary-label fw-semibold",
                      innerHTML: _unref(t)('fr.tax_summary.total_taxes', 'Totale da versare')
                    }, null, 8, _hoisted_104),
                    _createElementVNode("div", _hoisted_105, _toDisplayString(formatCurrency(__props.summaryData.totaleImposte)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", {
                          class: "d-inline-block rounded-circle me-2",
                          style: {"width":"8px","height":"8px","background-color":"#dc3545"}
                        }, null, -1)),
                        _createElementVNode("span", {
                          innerHTML: _unref(t)('fr.tax_breakdown.legend_substitute_tax', 'Imp. Sost.')
                        }, null, 8, _hoisted_109)
                      ]),
                      _createElementVNode("div", _hoisted_110, _toDisplayString(formatCurrency(__props.chartTaxTotal)), 1)
                    ]),
                    (__props.contributionType === 'PROFESSIONAL')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("div", _hoisted_112, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#fd7e14"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_soggettivo', 'Contrib. Sogg.')
                              }, null, 8, _hoisted_113)
                            ]),
                            _createElementVNode("div", _hoisted_114, _toDisplayString(formatCurrency(__props.chartContribSoggettivo)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("div", _hoisted_116, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#ffc107"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_integrativo', 'Contrib. Integr.')
                              }, null, 8, _hoisted_117)
                            ]),
                            _createElementVNode("div", _hoisted_118, _toDisplayString(formatCurrency(__props.chartContribIntegrativo)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", _hoisted_120, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#9c27b0"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_contrib_maternita', 'Contrib. Matern.')
                              }, null, 8, _hoisted_121)
                            ]),
                            _createElementVNode("div", _hoisted_122, _toDisplayString(formatCurrency(__props.chartContribMaternita)), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_123, [
                            _createElementVNode("div", _hoisted_124, [
                              _cache[18] || (_cache[18] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#fd7e14"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_inps_variable', 'INPS Var.')
                              }, null, 8, _hoisted_125)
                            ]),
                            _createElementVNode("div", _hoisted_126, _toDisplayString(formatCurrency(__props.chartInpsVariableTotal)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _cache[19] || (_cache[19] = _createElementVNode("span", {
                                class: "d-inline-block rounded-circle me-2",
                                style: {"width":"8px","height":"8px","background-color":"#ffc107"}
                              }, null, -1)),
                              _createElementVNode("span", {
                                innerHTML: _unref(t)('fr.tax_breakdown.legend_inps_fixed', 'INPS Fis.')
                              }, null, 8, _hoisted_129)
                            ]),
                            _createElementVNode("div", _hoisted_130, _toDisplayString(formatCurrency(__props.chartInpsFixedTotal)), 1)
                          ])
                        ], 64)),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", _hoisted_132, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", {
                          class: "d-inline-block rounded-circle me-2",
                          style: {"width":"8px","height":"8px","background-color":"#28a745"}
                        }, null, -1)),
                        _createElementVNode("span", {
                          innerHTML: _unref(t)('fr.tax_breakdown.legend_profit', 'Utile')
                        }, null, 8, _hoisted_133)
                      ]),
                      _createElementVNode("div", _hoisted_134, _toDisplayString(formatCurrency(utile.value)), 1)
                    ])
                  ])
                ], 512), [
                  [_vShow, showDetails.value]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!__props.showSummary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
              (isClient.value)
                ? (_openBlock(), _createBlock(_component_apexchart, {
                    key: 0,
                    type: "donut",
                    height: "200",
                    options: chartOptions.value,
                    series: chartSeries.value
                  }, null, 8, ["options", "series"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (__props.calculationDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary btn-sm w-100",
                type: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": '#calculationDetailsModal-' + modalId.value
              }, _toDisplayString(_unref(t)('fr.tax_breakdown.show_calculation_details', 'Mostra dettagli calcolo')), 9, _hoisted_137)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.calculationDetails)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal fade",
          id: 'calculationDetailsModal-' + modalId.value,
          tabindex: "-1",
          "aria-labelledby": 'calculationDetailsModalLabel-' + modalId.value,
          "aria-hidden": "true"
        }, [
          _createElementVNode("div", _hoisted_139, [
            _createElementVNode("div", _hoisted_140, [
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("h5", {
                  class: "modal-title",
                  id: 'calculationDetailsModalLabel-' + modalId.value
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("i", { class: "ri-calculator-line me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('fr.tax_breakdown.calculation_details_title', 'Dettagli Calcolo Fiscale')), 1)
                ], 8, _hoisted_142),
                _cache[22] || (_cache[22] = _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("div", _hoisted_144, [
                  _createElementVNode("div", _hoisted_145, [
                    _cache[23] || (_cache[23] = _createElementVNode("i", {
                      class: "text-primary",
                      style: {"font-size":"1.2rem","margin-top":"2px"}
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_146, _toDisplayString(__props.calculationDetails.summary), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_147, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.calculationDetails.steps, (step, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "step-item mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("div", _hoisted_149, [
                          _createElementVNode("span", _hoisted_150, _toDisplayString(step.title), 1)
                        ]),
                        _createElementVNode("div", _hoisted_151, _toDisplayString(step.result), 1)
                      ]),
                      (step.formula)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                            _createElementVNode("div", _hoisted_153, [
                              _createElementVNode("code", _hoisted_154, _toDisplayString(step.formula), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_155, [
                        _createElementVNode("p", _hoisted_156, [
                          _createElementVNode("small", null, _toDisplayString(step.description), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("button", _hoisted_158, [
                  _cache[24] || (_cache[24] = _createElementVNode("i", { class: "ri-close-line me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('fr.common.close', 'Chiudi')), 1)
                ])
              ])
            ])
          ])
        ], 8, _hoisted_138))
      : _createCommentVNode("", true)
  ], 64))
}
}

})